/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { BRAND_URL } from "../../../../configuration";
import { FormattedMessage } from "react-intl";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const backgroundImageUrl = BRAND_URL + "/client_card.png";

export function ClientsCounterWidget({ className, widgetHeight = "150px" }) {
  const { isLoading, counter } = useSelector((state) => ({
    isLoading: state.dashboard.countersLoading,
    counter:
      state.dashboard?.counters?.clientCounters?.find((c) => c.counterType === "TOTAL")?.value || 0,
  }));

  const history = useHistory();

  return (
    <div
      role="button"
      onClick={() => history.push("/clients")}
      className={`card card-custom bgi-no-repeat ${className}`}
      style={{
        height: widgetHeight,
        backgroundColor: "#663259",
        backgroundSize: "cover",
        backgroundImage: `url("${backgroundImageUrl}")`,
      }}
    >
      <div className="card-body">
        <span className={`svg-icon svg-icon-3x svg-icon-white`}>
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
        </span>
        <div className="text-white font-weight-bolder font-size-h2 mt-3">
          {isLoading ? (
            <span className="spinner spinner-lg spinner-white mr-12" />
          ) : (
            <span>{counter}</span>
          )}
        </div>
        <div className="text-white text-hover-primary font-weight-bold font-size-lg mt-1">
          <FormattedMessage id="CLIENT.TITLE" />
        </div>
      </div>
    </div>
  );
}
